import Vue from 'vue'
import App from './views/App'
import VueMeta from 'vue-meta'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import router from './router'
import {firestore, storage, auth, functions} from './firebase'

Vue.config.productionTip = false
Vue.prototype.$firestore = firestore;
Vue.prototype.$storage = storage;
Vue.prototype.$functions = functions;
Vue.prototype.$auth = auth;
Vue.use(VueMeta)

auth.onAuthStateChanged((user)=>{
 console.log(user);
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
